module.exports = __webpack_public_path__ + "static/media/GSbg.88480f1e.jpg";